// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"129":"a938432a","295":"ca17cb5a","453":"adff3311","662":"b5cdc83d","680":"f55a4732"}[chunkId] + ".chunk.js";
};